module.exports = __webpack_public_path__ + "static/media/peristyl.32807d43.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/peristyl.JPG
// module id = 775
// module chunks = 0